module.exports = __webpack_public_path__ + "img/king.9d60e408.png";